// 存储localStorage配置
export function fnCookie(_key, _value, cb) {
	if (typeof _value !== 'undefined' && typeof _value !== 'function') {
		localStorage.setItem(_key, JSON.stringify(_value))
		cb && cb(_value)
	} else {
		let _result
		if ([null, 'remove'].indexOf(localStorage.getItem(_key)) !== -1) {
			_result = undefined
		} else {
			_result = JSON.parse(localStorage.getItem(_key))
		}
		if (typeof _value === 'function') {
			_value && _value(_result)
		} else {
			cb && cb(_result)
		}
		return _result
	}
}

export function fnRmCookie(_key, cb) {
	localStorage.removeItem(_key)
	cb && cb(true)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js